// Authorization
export const AUTHORIZED = 'AUTHORIZED';
export const LOGIN = 'LOGIN';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REFRESH = 'REFRESH';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_SILENT = 'LOGIN_SILENT';
export const LOGIN_PROFILE = 'LOGIN_PROFILE';
export const NO_USER = 'NO_USER';
export const LOGOUT = 'LOGOUT';

// UI state etc.
export const GLOBAL_ERROR_DISMISS = 'GLOBAL_ERROR_DISMISS';

export const DAILYPLANNING_ERROR_DISMISS = 'DAILYPLANNING_ERROR_DISMISS';
export const DAILYPLANNING_SUCCESS_DISMISS = 'DAILYPLANNING_SUCCESS_DISMISS';
export const DAILYPLANNING_DETAILS_REQUEST = 'DAILYPLANNING_DETAILS_REQUEST';
export const DAILYPLANNING_DETAILS_SUCCESS = 'DAILYPLANNING_DETAILS_SUCCESS';
export const DAILYPLANNING_DETAILS_FAILURE = 'DAILYPLANNING_DETAILS_FAILURE';

export const DIALOG_HIDE = 'DIALOG_HIDE';
export const DIALOG_SHOW = 'DIALOG_SHOW';
export const DISMISS_PATIENT_SEARCH_ERROR = 'DISMISS_PATIENT_SEARCH_ERROR';
export const DISMISS_PATIENT_SEARCH_SUCCESS = 'DISMISS_PATIENT_SEARCH_SUCCESS';
export const FILTERS_UPDATE = 'FILTERS_UPDATE';
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
export const SELECTED_DATE_UPDATE = 'SELECTED_DATE_UPDATE';
export const SELECTOR_OPTIONS_GET_FAILURE = 'SELECTOR_OPTIONS_GET_FAILURE';
export const SELECTOR_OPTIONS_GET_REQUEST = 'SELECTOR_OPTIONS_GET_REQUEST';
export const SELECTOR_OPTIONS_GET_SUCCESS = 'SELECTOR_OPTIONS_GET_SUCCESS';
export const SYNCHRONIZE_FAILURE = 'SYNCHRONIZE_FAILURE';
export const SYNCHRONIZE_REQUEST = 'SYNCHRONIZE_REQUEST';
export const SYNCHRONIZE_SUCCESS = 'SYNCHRONIZE_SUCCESS';
export const TABLE_DATA_GET_FAILURE = 'TABLE_DATA_GET_FAILURE';
export const TABLE_DATA_GET_REQUEST = 'TABLE_DATA_GET_REQUEST';
export const TABLE_DATA_GET_SUCCESS = 'TABLE_DATA_GET_SUCCESS';
export const TABLE_DATA_SUCCESS_DISMISS = 'TABLE_DATA_SUCCESS_DISMISS';
export const TABLE_DATA_FAILURE_DISMISS = 'TABLE_DATA_FAILURE_DISMISS';
export const TABLE_SEARCH_PARAMS_CLEAR = 'TABLE_SEARCH_PARAMS_CLEAR';
export const TABLE_SEARCH_PARAMS_UPDATE = 'TABLE_SEARCH_PARAMS_UPDATE';
export const TREATMENT_INSTANCE_SORTING_SET = 'TREATMENT_INSTANCE_SORTING_SET';
export const TRAVEL_TIME_FOR_TREATMENT_GET_REQUEST = 'TRAVEL_TIME_FOR_TREATMENT_GET_REQUEST';
export const TRAVEL_TIME_FOR_TREATMENT_GET_SUCCESS = 'TRAVEL_TIME_FOR_TREATMENT_GET_SUCCESS';
export const TRAVEL_TIME_FOR_TREATMENT_GET_FAILURE = 'TRAVEL_TIME_FOR_TREATMENT_GET_FAILURE';
export const SCHEDULER_MAP_CLINICIAN_SELECT = 'SCHEDULER_MAP_CLINICIAN_SELECT';
export const SCHEDULER_MAP_VIEW_CHANGE = 'SCHEDULER_MAP_VIEW_CHANGE';
export const DOWNLOAD_CLINICIAN_PLAN = 'DOWNLOAD_CLINICIAN_PLAN';
export const DOWNLOAD_CLINICIAN_PLAN_SUCCESS = 'DOWNLOAD_CLINICIAN_PLAN_SUCCESS';
export const DOWNLOAD_CLINICIAN_PLAN_FAILURE = 'DOWNLOAD_CLINICIAN_PLAN_FAILURE';
export const LIVE_TRACKING_UPDATE = 'LIVE_TRACKING_UPDATE';

export const SELECTED_AUDIT_OPTIONS_SAVE = 'SELECTED_AUDIT_OPTIONS_SAVE';
export const SELECTED_AUDIT_OPTIONS_CLEAR = 'SELECTED_AUDIT_OPTIONS_CLEAR';

export const VISIT_ACTUAL_UPDATE_VISIT_TIME = 'VISIT_ACTUAL_UPDATE_VISIT_TIME';
export const VISIT_ACTUAL_ADD_ACTIVITY_TIME = 'VISIT_ACTUAL_ADD_ACTIVITY_TIME';

export const POSTCODE_DISTANCE_GET_FAILURE = 'POSTCODE_DISTANCE_GET_FAILURE';
export const POSTCODE_DISTANCE_GET_REQUEST = 'POSTCODE_DISTANCE_GET_REQUEST';
export const POSTCODE_DISTANCE_GET_SUCCESS = 'POSTCODE_DISTANCE_GET_SUCCESS';

export const HOME_TO_VISIT_POSTCODE_DISTANCE_GET_REQUEST = 'HOME_TO_VISIT_POSTCODE_DISTANCE_GET_REQUEST';
export const HOME_TO_VISIT_POSTCODE_DISTANCE_GET_SUCCESS = 'HOME_TO_VISIT_POSTCODE_DISTANCE_GET_SUCCESS';
export const HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE = 'HOME_TO_VISIT_POSTCODE_DISTANCE_GET_FAILURE';
export const HOME_TO_VISIT_POSTCODE_DISTANCE_ERROR_DISMISS = 'HOME_TO_VISIT_POSTCODE_DISTANCE_ERROR_DISMISS';

export const BULK_CANCEL_ISINPROGRESS = 'BULK_CANCEL_ISINPROGRESS';

export const GRID_FILTERS_ADD = 'GRID_FILTERS_ADD';
export const GRID_FILTERS_UPDATE = 'GRID_FILTERS_UPDATE';
export const GRID_FILTERS_CLEAR = 'GRID_FILTERS_CLEAR';

// Entities
export const ACTIVITY_ACTIVATE_FAILURE = 'ACTIVITY_ACTIVATE_FAILURE';
export const ACTIVITY_ACTIVATE_REQUEST = 'ACTIVITY_ACTIVATE_REQUEST';
export const ACTIVITY_ACTIVATE_SUCCESS = 'ACTIVITY_ACTIVATE_SUCCESS';
export const ACTIVITY_CREATE_FAILURE = 'ACTIVITY_CREATE_FAILURE';
export const ACTIVITY_CREATE_REQUEST = 'ACTIVITY_CREATE_REQUEST';
export const ACTIVITY_CREATE_SUCCESS = 'ACTIVITY_CREATE_SUCCESS';
export const ACTIVITY_DEACTIVATE_FAILURE = 'ACTIVITY_DEACTIVATE_FAILURE';
export const ACTIVITY_DEACTIVATE_REQUEST = 'ACTIVITY_DEACTIVATE_REQUEST';
export const ACTIVITY_DEACTIVATE_SUCCESS = 'ACTIVITY_DEACTIVATE_SUCCESS';
export const ACTIVITY_GET_FAILURE = 'ACTIVITY_GET_FAILURE';
export const ACTIVITY_GET_REQUEST = 'ACTIVITY_GET_REQUEST';
export const ACTIVITY_GET_SUCCESS = 'ACTIVITY_GET_SUCCESS';
export const ACTIVITY_UPDATE_FAILURE = 'ACTIVITY_UPDATE_FAILURE';
export const ACTIVITY_UPDATE_REQUEST = 'ACTIVITY_UPDATE_REQUEST';
export const ACTIVITY_UPDATE_SUCCESS = 'ACTIVITY_UPDATE_SUCCESS';

export const ASSIGNMENT_CREATE_FAILURE = 'ASSIGNMENT_CREATE_FAILURE';
export const ASSIGNMENT_CREATE_REQUEST = 'ASSIGNMENT_CREATE_REQUEST';
export const ASSIGNMENT_CREATE_SUCCESS = 'ASSIGNMENT_CREATE_SUCCESS';
export const ASSIGNMENT_DELETE_FAILURE = 'ASSIGNMENT_DELETE_FAILURE';
export const ASSIGNMENT_DELETE_REQUEST = 'ASSIGNMENT_DELETE_REQUEST';
export const ASSIGNMENT_DELETE_SUCCESS = 'ASSIGNMENT_DELETE_SUCCESS';
export const ASSIGNMENT_RESCHEDULE_FAILURE = 'ASSIGNMENT_RESCHEDULE_FAILURE';
export const ASSIGNMENT_RESCHEDULE_REQUEST = 'ASSIGNMENT_RESCHEDULE_REQUEST';
export const ASSIGNMENT_RESCHEDULE_SUCCESS = 'ASSIGNMENT_RESCHEDULE_SUCCESS';

export const ORG_UNITS_CURRENT_USER_GET_REQUEST = 'ORG_UNITS_CURRENT_USER_GET_REQUEST';
export const ORG_UNITS_CURRENT_USER_GET_SUCCESS = 'ORG_UNITS_CURRENT_USER_GET_SUCCESS';
export const ORG_UNITS_CURRENT_USER_GET_FAILURE = 'ORG_UNITS_CURRENT_USER_GET_FAILURE';
export const ORG_UNITS_DEFAULT_FOR_DAY_SET = 'ORG_UNITS_DEFAULT_FOR_DAY_SET';

export const PATIENT_GET_FAILURE = 'PATIENT_GET_FAILURE';
export const PATIENT_GET_REQUEST = 'PATIENT_GET_REQUEST';
export const PATIENT_GET_SUCCESS = 'PATIENT_GET_SUCCESS';
export const PATIENT_UPDATE_FAILURE = 'PATIENT_UPDATE_FAILURE';
export const PATIENT_UPDATE_REQUEST = 'PATIENT_UPDATE_REQUEST';
export const PATIENT_UPDATE_SUCCESS = 'PATIENT_UPDATE_SUCCESS';
export const PATIENT_ADD_FAILURE = 'PATIENT_ADD_FAILURE';
export const PATIENT_ADD_REQUEST = 'PATIENT_ADD_REQUEST';
export const PATIENT_ADD_SUCCESS = 'PATIENT_ADD_SUCCESS';
export const PATIENT_SYNC_REQUEST = 'PATIENT_SYNC_REQUEST';
export const PATIENT_SYNC_SUCCESS = 'PATIENT_SYNC_SUCCESS';
export const PATIENT_SYNC_FAILURE = 'PATIENT_SYNC_FAILURE';
export const PATIENT_SYNC_RESET = 'PATIENT_SYNC_RESET';

export const PATIENT_CLINICIAN_EXCLUDE_FAILURE = 'PATIENT_CLINICIAN_EXCLUDE_FAILURE';
export const PATIENT_CLINICIAN_EXCLUDE_REQUEST = 'PATIENT_CLINICIAN_EXCLUDE_REQUEST';
export const PATIENT_CLINICIAN_EXCLUDE_SUCCESS = 'PATIENT_CLINICIAN_EXCLUDE_SUCCESS';

export const PATIENT_EXCLUDED_CLINICIAN_REMOVE_FAILURE = 'PATIENT_CLINICIAN_EXCLUDE_FAILURE';
export const PATIENT_EXCLUDED_CLINICIAN_REMOVE_REQUEST = 'PATIENT_EXCLUDED_CLINICIAN_REMOVE_REQUEST';
export const PATIENT_EXCLUDED_CLINICIAN_REMOVE_SUCCESS = 'PATIENT_EXCLUDED_CLINICIAN_REMOVE_SUCCESS';

export const POSTINGS_GET_FAILURE = 'POSTINGS_GET_FAILURE';
export const POSTINGS_GET_REQUEST = 'POSTINGS_GET_REQUEST';
export const POSTINGS_GET_SUCCESS = 'POSTINGS_GET_SUCCESS';
export const POSTINGS_RESET_DATA = 'POSTINGS_RESET_DATA';

export const LOCATIONSFORPOSTINGS_GET_FAILURE = 'LOCATIONSFORPOSTINGS_GET_FAILURE';
export const LOCATIONSFORPOSTINGS_GET_REQUEST = 'LOCATIONSFORPOSTINGS_GET_REQUEST';
export const LOCATIONSFORPOSTINGS_GET_SUCCESS = 'LOCATIONSFORPOSTINGS_GET_SUCCESS';

export const REFERRAL_CREATE_FAILURE = 'REFERRAL_CREATE_FAILURE';
export const REFERRAL_CREATE_REQUEST = 'REFERRAL_CREATE_REQUEST';
export const REFERRAL_CREATE_SUCCESS = 'REFERRAL_CREATE_SUCCESS';
export const REFERRAL_CREATE_ERRORS_DISMISS = 'REFERRAL_CREATE_ERRORS_DISMISS';
export const REFERRAL_GET_FAILURE = 'REFERRAL_GET_FAILURE';
export const REFERRAL_GET_REQUEST = 'REFERRAL_GET_REQUEST';
export const REFERRAL_GET_SUCCESS = 'REFERRAL_GET_SUCCESS';
export const REFERRAL_UPDATE_FAILURE = 'REFERRAL_UPDATE_FAILURE';
export const REFERRAL_UPDATE_REQUEST = 'REFERRAL_UPDATE_REQUEST';
export const REFERRAL_UPDATE_SUCCESS = 'REFERRAL_UPDATE_SUCCESS';
export const REFERRAL_UPDATE_ERRORS_DISMISS = 'REFERRAL_UPDATE_ERRORS_DISMISS';
export const REFERRAL_CLOSE_FAILURE = 'REFERRAL_CLOSE_FAILURE';
export const REFERRAL_CLOSE_REQUEST = 'REFERRAL_CLOSE_REQUEST';
export const REFERRAL_CLOSE_SUCCESS = 'REFERRAL_CLOSE_SUCCESS';
export const REFERRAL_GET_CLOSE_DATE_RANGE_REQUEST = 'REFERRAL_GET_CLOSE_DATE_RANGE_REQUEST';
export const REFERRAL_GET_CLOSE_DATE_RANGE_SUCCESS = 'REFERRAL_GET_CLOSE_DATE_RANGE_SUCCESS';
export const REFERRAL_GET_CLOSE_DATE_RANGE_FAILURE = 'REFERRAL_GET_CLOSE_DATE_RANGE_FAILURE';
export const REFERRALS_SYNC_REQUEST = 'REFERRALS_SYNC_REQUEST';
export const REFERRALS_SYNC_SUCCESS = 'REFERRALS_SYNC_SUCCESS';
export const REFERRALS_SYNC_FAILURE = 'REFERRALS_SYNC_FAILURE';
export const REFERRALS_SYNC_RESET = 'REFERRALS_SYNC_RESET';

export const SETTINGS_GET_REQUEST = 'SETTINGS_GET_REQUEST';
export const SETTINGS_GET_SUCCESS = 'SETTINGS_GET_SUCCESS';
export const SETTINGS_GET_FAILURE = 'SETTINGS_GET_FAILURE';

export const SYNCHRONIZATION_DETAILS_GET_FAILURE = 'SYNCHRONIZATION_DETAILS_GET_FAILURE';
export const SYNCHRONIZATION_DETAILS_GET_REQUEST = 'SYNCHRONIZATION_DETAILS_GET_REQUEST';
export const SYNCHRONIZATION_DETAILS_GET_SUCCESS = 'SYNCHRONIZATION_DETAILS_GET_SUCCESS';

export const SYSTEM_INFO_GET_FAILURE = 'SYSTEM_INFO_GET_FAILURE';
export const SYSTEM_INFO_GET_REQUEST = 'SYSTEM_INFO_GET_REQUEST';
export const SYSTEM_INFO_GET_SUCCESS = 'SYSTEM_INFO_GET_SUCCESS';

export const TIMESLOTS_DEFAULT_PACKAGE_GET_FAILURE = 'TIMESLOTS_DEFAULT_PACKAGE_GET_FAILURE';
export const TIMESLOTS_DEFAULT_PACKAGE_GET_REQUEST = 'TIMESLOTS_DEFAULT_PACKAGE_GET_REQUEST';
export const TIMESLOTS_DEFAULT_PACKAGE_GET_SUCCESS = 'TIMESLOTS_DEFAULT_PACKAGE_GET_SUCCESS';

export const TIMESLOT_ADD = 'TIMESLOT_ADD';
export const TIMESLOT_EDIT = 'TIMESLOT_EDIT';
export const TIMESLOT_DELETE = 'TIMESLOT_DELETE';
export const TIMESLOT_SAVE_REQUEST = 'TIMESLOT_SAVE_REQUEST';
export const TIMESLOT_SAVE_SUCCESS = 'TIMESLOT_SAVE_SUCCESS';
export const TIMESLOT_SAVE_FAILURE = 'TIMESLOT_SAVE_FAILURE';

export const TREATMENT_CREATE_FAILURE = 'TREATMENT_CREATE_FAILURE';
export const TREATMENT_CREATE_REQUEST = 'TREATMENT_CREATE_REQUEST';
export const TREATMENT_CREATE_SUCCESS = 'TREATMENT_CREATE_SUCCESS';
export const TREATMENT_GET_FAILURE = 'TREATMENT_GET_FAILURE';
export const TREATMENT_GET_REQUEST = 'TREATMENT_GET_REQUEST';
export const TREATMENT_GET_SUCCESS = 'TREATMENT_GET_SUCCESS';
export const TREATMENT_DETAILS_GET_FAILURE = 'TREATMENT_DETAILS_GET_FAILURE';
export const TREATMENT_DETAILS_GET_REQUEST = 'TREATMENT_DETAILS_GET_REQUEST';
export const TREATMENT_DETAILS_GET_SUCCESS = 'TREATMENT_DETAILS_GET_SUCCESS';
export const TREATMENT_UPDATE_FAILURE = 'TREATMENT_UPDATE_FAILURE';
export const TREATMENT_UPDATE_REQUEST = 'TREATMENT_UPDATE_REQUEST';
export const TREATMENT_UPDATE_SUCCESS = 'TREATMENT_UPDATE_SUCCESS';
export const TREATMENT_DISCARD_FAILURE = 'TREATMENT_DISCARD_FAILURE';
export const TREATMENT_DISCARD_REQUEST = 'TREATMENT_DISCARD_REQUEST';
export const TREATMENT_DISCARD_SUCCESS = 'TREATMENT_DISCARD_SUCCESS';
export const TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_REQUEST = 'TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_REQUEST';
export const TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_SUCCESS = 'TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_SUCCESS';
export const TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_FAILURE = 'TREATMENT_FUTURE_ASSIGNED_INSTANCES_GET_FAILURE';
export const TREATMENT_CREATE_RETROSPECTIVE_VISIT_FAILURE = 'TREATMENT_CREATE_RETROSPECTIVE_VISIT_FAILURE';
export const TREATMENT_CREATE_RETROSPECTIVE_VISIT_REQUEST = 'TREATMENT_CREATE_RETROSPECTIVE_VISIT_REQUEST';
export const TREATMENT_CREATE_RETROSPECTIVE_VISIT_SUCCESS = 'TREATMENT_CREATE_RETROSPECTIVE_VISIT_SUCCESS';
export const TREATMENTS_SYNC_REQUEST = 'TREATMENTS_SYNC_REQUEST';
export const TREATMENTS_SYNC_SUCCESS = 'TREATMENTS_SYNC_SUCCESS';
export const TREATMENTS_SYNC_FAILURE = 'TREATMENTS_SYNC_FAILURE';
export const TREATMENTS_SYNC_RESET = 'TREATMENTS_SYNC_RESET';

export const TREATMENT_INSTANCE_CANCEL_FAILURE = 'TREATMENT_INSTANCE_CANCEL_FAILURE';
export const TREATMENT_INSTANCE_CANCEL_REQUEST = 'TREATMENT_INSTANCE_CANCEL_REQUEST';
export const TREATMENT_INSTANCE_CANCEL_SUCCESS = 'TREATMENT_INSTANCE_CANCEL_SUCCESS';
export const TREATMENT_INSTANCES_GET_FAILURE = 'TREATMENT_INSTANCES_GET_FAILURE';
export const TREATMENT_INSTANCES_GET_REQUEST = 'TREATMENT_INSTANCES_GET_REQUEST';
export const TREATMENT_INSTANCES_GET_SUCCESS = 'TREATMENT_INSTANCES_GET_SUCCESS';
export const TREATMENT_INSTANCE_UPDATE_FAILURE = 'TREATMENT_INSTANCE_UPDATE_FAILURE';
export const TREATMENT_INSTANCE_UPDATE_REQUEST = 'TREATMENT_INSTANCE_UPDATE_REQUEST';
export const TREATMENT_INSTANCE_UPDATE_SUCCESS = 'TREATMENT_INSTANCE_UPDATE_SUCCESS';
export const TREATMENT_INSTANCE_ADD_OVERRIDE_REQUEST = 'TREATMENT_INSTANCE_ADD_OVERRIDE_REQUEST';
export const TREATMENT_INSTANCE_ADD_OVERRIDE_SUCCESS = 'TREATMENT_INSTANCE_ADD_OVERRIDE_SUCCESS';
export const TREATMENT_INSTANCE_ADD_OVERRIDE_FAILURE = 'TREATMENT_INSTANCE_ADD_OVERRIDE_FAILURE';
export const TREATMENT_INSTANCE_REMOVE_OVERRIDE_REQUEST = 'TREATMENT_INSTANCE_ADD_OVERRIDE_REQUEST';
export const TREATMENT_INSTANCE_REMOVE_OVERRIDE_SUCCESS = 'TREATMENT_INSTANCE_ADD_OVERRIDE_SUCCESS';
export const TREATMENT_INSTANCE_REMOVE_OVERRIDE_FAILURE = 'TREATMENT_INSTANCE_ADD_OVERRIDE_FAILURE';
export const TREATMENT_INSTANCES_GET_UNALLOCATED_TIME_FAILURE = 'TREATMENT_INSTANCES_GET_UNALLOCATED_TIME_FAILURE';
export const TREATMENT_INSTANCES_GET_UNALLOCATED_TIME_REQUEST = 'TREATMENT_INSTANCES_GET_UNALLOCATED_TIME_REQUEST';
export const TREATMENT_INSTANCES_GET_UNALLOCATED_TIME_SUCCESS = 'TREATMENT_INSTANCES_GET_UNALLOCATED_TIME_SUCCESS';

export const TREATMENTS_PATTERN_DATES_GET_REQUEST = 'TREATMENTS_PATTERN_DATES_GET_REQUEST';
export const TREATMENTS_PATTERN_DATES_GET_SUCCESS = 'TREATMENTS_PATTERN_DATES_GET_SUCCESS';
export const TREATMENTS_PATTERN_DATES_GET_FAILURE = 'TREATMENTS_PATTERN_DATES_GET_FAILURE';

export const VISIT_ACTUAL_GET_FAILURE = 'VISIT_ACTUAL_GET_FAILURE';
export const VISIT_ACTUAL_GET_REQUEST = 'VISIT_ACTUAL_GET_REQUEST';
export const VISIT_ACTUAL_GET_SUCCESS = 'VISIT_ACTUAL_GET_SUCCESS';
export const VISIT_ACTUAL_UPDATE_FAILURE = 'VISIT_ACTUAL_UPDATE_FAILURE';
export const VISIT_ACTUAL_UPDATE_REQUEST = 'VISIT_ACTUAL_UPDATE_REQUEST';
export const VISIT_ACTUAL_UPDATE_SUCCESS = 'VISIT_ACTUAL_UPDATE_SUCCESS';
export const VISIT_ACTUAL_ERROR_DISMISS = 'VISIT_ACTUAL_ERROR_DISMISS';

export const HISTORIC_VISITS_GET_RESCHEDULED_INFORMATION_REQUEST =
  'HISTORIC_VISITS_GET_RESCHEDULED_INFORMATION_REQUEST';
export const HISTORIC_VISITS_GET_RESCHEDULED_INFORMATION_SUCCESS =
  'HISTORIC_VISITS_GET_RESCHEDULED_INFORMATION_SUCCESS';
export const HISTORIC_VISITS_GET_RESCHEDULED_INFORMATION_FAILURE =
  'HISTORIC_VISITS_GET_RESCHEDULED_INFORMATION_FAILURE';

export const CANCELLATION_REASON_CREATE_REQUEST = 'CANCELLATION_REASON_CREATE_REQUEST';
export const CANCELLATION_REASON_CREATE_SUCCESS = 'CANCELLATION_REASON_CREATE_SUCCESS';
export const CANCELLATION_REASON_CREATE_FAILURE = 'CANCELLATION_REASON_CREATE_FAILURE';

export const CANCELLATION_REASON_UPDATE_REQUEST = 'CANCELLATION_REASON_UPDATE_REQUEST';
export const CANCELLATION_REASON_UPDATE_SUCCESS = 'CANCELLATION_REASON_UPDATE_SUCCESS';
export const CANCELLATION_REASON_UPDATE_FAILURE = 'CANCELLATION_REASON_UPDATE_FAILURE';

export const ACTIVITY_TYPE_CREATE_REQUEST = 'ACTIVITY_TYPE_CREATE_REQUEST';
export const ACTIVITY_TYPE_CREATE_SUCCESS = 'ACTIVITY_TYPE_CREATE_SUCCESS';
export const ACTIVITY_TYPE_CREATE_FAILURE = 'ACTIVITY_TYPE_CREATE_FAILURE';

export const ACTIVITY_TYPE_UPDATE_REQUEST = 'ACTIVITY_TYPE_UPDATE_REQUEST';
export const ACTIVITY_TYPE_UPDATE_SUCCESS = 'ACTIVITY_TYPE_UPDATE_SUCCESS';
export const ACTIVITY_TYPE_UPDATE_FAILURE = 'ACTIVITY_TYPE_UPDATE_FAILURE';

export const ACTIVITY_TYPE_GET_REQUEST = 'ACTIVITY_TYPE_GET_REQUEST';
export const ACTIVITY_TYPE_GET_SUCCESS = 'ACTIVITY_TYPE_GET_SUCCESS';
export const ACTIVITY_TYPE_GET_FAILURE = 'ACTIVITY_TYPE_GET_FAILURE';

export const AUTOALLOCATE_WEIGHTINGS_GET_REQUEST = 'AUTOALLOCATE_WEIGHTINGS_GET_REQUEST';
export const AUTOALLOCATE_WEIGHTINGS_GET_SUCCESS = 'AUTOALLOCATE_WEIGHTINGS_GET_SUCCESS';
export const AUTOALLOCATE_WEIGHTINGS_GET_FAILURE = 'AUTOALLOCATE_WEIGHTINGS_GET_FAILURE';

export const AUTOALLOCATE_WEIGHTINGS_UPDATE_REQUEST = 'AUTOALLOCATE_WEIGHTINGS_UPDATE_REQUEST';
export const AUTOALLOCATE_WEIGHTINGS_UPDATE_SUCCESS = 'AUTOALLOCATE_WEIGHTINGS_UPDATE_SUCCESS';
export const AUTOALLOCATE_WEIGHTINGS_UPDATE_FAILURE = 'AUTOALLOCATE_WEIGHTINGS_UPDATE_FAILURE';

// Reports
export const REPORT_TYPE_SELECT = 'REPORT_TYPE_SELECT';
export const GENERATE_REPORT_REQUEST = 'GENERATE_REPORT_REQUEST';
export const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS';
export const GENERATE_REPORT_FAILURE = 'GENERATE_REPORT_FAILURE';

export const AUTO_ALLOCATE_REQUEST = 'AUTO_ALLOCATE_REQUEST';
export const AUTO_ALLOCATE_SUCCESS = 'AUTO_ALLOCATE_SUCCESS';
export const AUTO_ALLOCATE_FAILURE = 'AUTO_ALLOCATE_FAILURE';

export const AUTO_UNALLOCATE_REQUEST = 'AUTO_UNALLOCATE_REQUEST';
export const AUTO_UNALLOCATE_SUCCESS = 'AUTO_UNALLOCATE_SUCCESS';
export const AUTO_UNALLOCATE_FAILURE = 'AUTO_UNALLOCATE_FAILURE';

export const GET_AUTO_ALLOCATION_DETAILS_REQUEST = 'GET_AUTO_ALLOCATION_DETAILS_REQUEST';
export const GET_AUTO_ALLOCATION_DETAILS_SUCCESS = 'GET_AUTO_ALLOCATION_DETAILS_SUCCESS';
export const GET_AUTO_ALLOCATION_DETAILS_FAILURE = 'GET_AUTO_ALLOCATION_DETAILS_FAILURE';
export const AUTO_ALLOCATE_LOG = 'AUTO_ALLOCATE_LOG';
export const AUTO_ALLOCATE_UPDATE_DATES = 'AUTO_ALLOCATE_UPDATE_DATES';

// Dashboard
export const TEAM_AVAILABILITY_REQUEST = 'TEAM_AVAILABILITY_REQUEST';
export const TEAM_AVAILABILITY_SUCCESS = 'TEAM_AVAILABILITY_SUCCESS';
export const TEAM_AVAILABILITY_FAILURE = 'TEAM_AVAILABILITY_FAILURE';

export const UPDATE_LUNCHBREAK_REQUEST = 'UPDATE_LUNCHBREAK_REQUEST';
export const UPDATE_LUNCHBREAK_SUCCESS = 'UPDATE_LUNCHBREAK_SUCCESS';
export const UPDATE_LUNCHBREAK_FAILURE = 'UPDATE_LUNCHBREAK_FAILURE';

export const NON_PATIENT_ACTIVITY_TYPE_CREATE_REQUEST = 'NON_PATIENT_ACTIVITY_TYPE_CREATE_REQUEST';
export const NON_PATIENT_ACTIVITY_TYPE_CREATE_SUCCESS = 'NON_PATIENT_ACTIVITY_TYPE_CREATE_SUCCESS';
export const NON_PATIENT_ACTIVITY_TYPE_CREATE_FAILURE = 'NON_PATIENT_ACTIVITY_TYPE_CREATE_FAILURE';

export const NON_PATIENT_ACTIVITY_TYPE_GET_REQUEST = 'NON_PATIENT_ACTIVITY_TYPE_GET_REQUEST';
export const NON_PATIENT_ACTIVITY_TYPE_GET_SUCCESS = 'NON_PATIENT_ACTIVITY_TYPE_GET_SUCCESS';
export const NON_PATIENT_ACTIVITY_TYPE_GET_FAILURE = 'NON_PATIENT_ACTIVITY_TYPE_GET_FAILURE';

export const NON_PATIENT_ACTIVITY_TYPE_UPDATE_REQUEST = 'NON_PATIENT_ACTIVITY_TYPE_UPDATE_REQUEST';
export const NON_PATIENT_ACTIVITY_TYPE_UPDATE_SUCCESS = 'NON_PATIENT_ACTIVITY_TYPE_UPDATE_SUCCESS';
export const NON_PATIENT_ACTIVITY_TYPE_UPDATE_FAILURE = 'NON_PATIENT_ACTIVITY_TYPE_UPDATE_FAILURE';

export const NON_PATIENT_ACTIVITY_CREATE_REQUEST = 'NON_PATIENT_ACTIVITY_CREATE_REQUEST';
export const NON_PATIENT_ACTIVITY_CREATE_SUCCESS = 'NON_PATIENT_ACTIVITY_CREATE_SUCCESS';
export const NON_PATIENT_ACTIVITY_CREATE_FAILURE = 'NON_PATIENT_ACTIVITY_CREATE_FAILURE';

export const NON_PATIENT_ACTIVITY_GET_REQUEST = 'NON_PATIENT_ACTIVITY_GET_REQUEST';
export const NON_PATIENT_ACTIVITY_GET_SUCCESS = 'NON_PATIENT_ACTIVITY_GET_SUCCESS';
export const NON_PATIENT_ACTIVITY_GET_FAILURE = 'NON_PATIENT_ACTIVITY_GET_FAILURE';

export const NON_PATIENT_ACTIVITY_UPDATE_REQUEST = 'NON_PATIENT_ACTIVITY_UPDATE_REQUEST';
export const NON_PATIENT_ACTIVITY_UPDATE_SUCCESS = 'NON_PATIENT_ACTIVITY_UPDATE_SUCCESS';
export const NON_PATIENT_ACTIVITY_UPDATE_FAILURE = 'NON_PATIENT_ACTIVITY_UPDATE_FAILURE';

export const NON_PATIENT_ACTIVITY_CANCEL_REQUEST = 'NON_PATIENT_ACTIVITY_CANCEL_REQUEST';
export const NON_PATIENT_ACTIVITY_CANCEL_SUCCESS = 'NON_PATIENT_ACTIVITY_CANCEL_SUCCESS';
export const NON_PATIENT_ACTIVITY_CANCEL_FAILURE = 'NON_PATIENT_ACTIVITY_CANCEL_FAILURE';

export const NON_PATIENT_ACTIVITY_ERROR_DISMISS = 'NON_PATIENT_ACTIVITY_ERROR_DISMISS';

export const REFERRAL_PRIORITY_CREATE_REQUEST = 'REFERRAL_PRIORITY_CREATE_REQUEST';
export const REFERRAL_PRIORITY_CREATE_SUCCESS = 'REFERRAL_PRIORITY_CREATE_SUCCESS';
export const REFERRAL_PRIORITY_CREATE_FAILURE = 'REFERRAL_PRIORITY_CREATE_FAILURE';

export const REFERRAL_PRIORITY_UPDATE_REQUEST = 'REFERRAL_PRIORITY_UPDATE_REQUEST';
export const REFERRAL_PRIORITY_UPDATE_SUCCESS = 'REFERRAL_PRIORITY_UPDATE_SUCCESS';
export const REFERRAL_PRIORITY_UPDATE_FAILURE = 'REFERRAL_PRIORITY_UPDATE_FAILURE';

export const REFERRAL_SOURCE_CREATE_REQUEST = 'REFERRAL_SOURCE_CREATE_REQUEST';
export const REFERRAL_SOURCE_CREATE_SUCCESS = 'REFERRAL_SOURCE_CREATE_SUCCESS';
export const REFERRAL_SOURCE_CREATE_FAILURE = 'REFERRAL_SOURCE_CREATE_FAILURE';

export const REFERRAL_SOURCE_UPDATE_REQUEST = 'REFERRAL_SOURCE_UPDATE_REQUEST';
export const REFERRAL_SOURCE_UPDATE_SUCCESS = 'REFERRAL_SOURCE_UPDATE_SUCCESS';
export const REFERRAL_SOURCE_UPDATE_FAILURE = 'REFERRAL_SOURCE_UPDATE_FAILURE';

export const REFERRAL_SERVICE_ERROR_DISMISS = 'REFERRAL_SERVICE_ERROR_DISMISS';

export const REFERRAL_SERVICE_CREATE_REQUEST = 'REFERRAL_SERVICE_CREATE_REQUEST';
export const REFERRAL_SERVICE_CREATE_SUCCESS = 'REFERRAL_SERVICE_CREATE_SUCCESS';
export const REFERRAL_SERVICE_CREATE_FAILURE = 'REFERRAL_SERVICE_CREATE_FAILURE';

export const REFERRAL_SERVICE_UPDATE_REQUEST = 'REFERRAL_SERVICE_UPDATE_REQUEST';
export const REFERRAL_SERVICE_UPDATE_SUCCESS = 'REFERRAL_SERVICE_UPDATE_SUCCESS';
export const REFERRAL_SERVICE_UPDATE_FAILURE = 'REFERRAL_SERVICE_UPDATE_FAILURE';

export const REFERRAL_SERVICE_VALIDATE_REQUEST = 'REFERRAL_SERVICE_VALIDATE_REQUEST';
export const REFERRAL_SERVICE_VALIDATE_SUCCESS = 'REFERRAL_SERVICE_VALIDATE_SUCCESS';
export const REFERRAL_SERVICE_VALIDATE_FAILURE = 'REFERRAL_SERVICE_VALIDATE_FAILURE';

export const MILEAGE_CAP_CREATE_FAILURE = 'MILEAGE_CAP_CREATE_FAILURE';
export const MILEAGE_CAP_CREATE_REQUEST = 'MILEAGE_CAP_CREATE_REQUEST';
export const MILEAGE_CAP_CREATE_SUCCESS = 'MILEAGE_CAP_CREATE_SUCCESS';

export const STARTING_POSTCODE_CREATE_FAILURE = 'STARTING_POSTCODE_CREATE_FAILURE';
export const STARTING_POSTCODE_CREATE_REQUEST = 'STARTING_POSTCODE_CREATE_REQUEST';
export const STARTING_POSTCODE_CREATE_SUCCESS = 'STARTING_POSTCODE_CREATE_SUCCESS';

export const NEXT_ID_REQUEST = 'NEXT_ID_REQUEST';
export const NEXT_ID_SUCCESS = 'NEXT_ID_SUCCESS';
export const NEXT_ID_FAILURE = 'NEXT_ID_FAILURE';

export const REMOVE_TREATMENT_INSTANCE = 'REMOVE_TREATMENT_INSTANCE';

export const TREATMENT_INSTANCES_BY_ASSIGNMENT_GET_REQUEST = 'TREATMENT_INSTANCES_BY_ASSIGNMENT_GET_REQUEST';
export const TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_SUCCESS = 'TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_SUCCESS';
export const TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_FAILURE = 'TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_FAILURE';

export const COPIES_POSTINGS_GET_REQUEST = 'COPIES_POSTINGS_GET_REQUEST';
export const COPIES_POSTINGS_GET_SUCCESS = 'COPIES_POSTINGS_GET_SUCCESS';
export const COPIES_POSTINGS_GET_FAILURE = 'COPIES_POSTINGS_GET_FAILURE';

export const UPDATE_POSTINGS_AFTER_ASSIGN_REQUEST = 'UPDATE_POSTINGS_AFTER_ASSIGN_REQUEST';
export const UPDATE_POSTINGS_AFTER_ASSIGN_SUCCESS = 'UPDATE_POSTINGS_AFTER_ASSIGN_SUCCESS';
export const UPDATE_POSTINGS_AFTER_ASSIGN_FAILURE = 'UPDATE_POSTINGS_AFTER_ASSIGN_FAILURE';

export const UPDATE_POSTINGS_AFTER_RESCHEDULE_REQUEST = 'UPDATE_POSTINGS_AFTER_RESCHEDULE_REQUEST';
export const UPDATE_POSTINGS_AFTER_RESCHEDULE_SUCCESS = 'UPDATE_POSTINGS_AFTER_RESCHEDULE_SUCCESS';
export const UPDATE_POSTINGS_AFTER_RESCHEDULE_FAILURE = 'UPDATE_POSTINGS_AFTER_RESCHEDULE_FAILURE';

export const UPDATE_POSTINGS_AFTER_UNASSIGN_REQUEST = 'UPDATE_POSTINGS_AFTER_UNASSIGN_REQUEST';
export const UPDATE_POSTINGS_AFTER_UNASSIGN_SUCCESS = 'UPDATE_POSTINGS_AFTER_UNASSIGN_SUCCESS';
export const UPDATE_POSTINGS_AFTER_UNASSIGN_FAILURE = 'UPDATE_POSTINGS_AFTER_UNASSIGN_FAILURE';

export const TREATMENT_INSTANCE_COPY_GET_REQUEST = 'TREATMENT_INSTANCE_COPY_GET_REQUEST';
export const TREATMENT_INSTANCE_COPY_GET_SUCCESS = 'TREATMENT_INSTANCE_COPY_GET_SUCCESS';
export const TREATMENT_INSTANCE_COPY_GET_FAILURE = 'TREATMENT_INSTANCE_COPY_GET_FAILURE';

export const REMOVE_TREATMENT_INSTANCE_COPIES = 'REMOVE_TREATMENT_INSTANCE_COPIES';
export const UPDATE_TIME_LEFT_TO_ALLOCATE = 'UPDATE_TIME_LEFT_TO_ALLOCATE';

export const TEAM_AVAILABILITY_GET_REQUEST = 'TEAM_AVAILABILITY_GET_REQUEST';
export const TEAM_AVAILABILITY_GET_SUCCESS = 'TEAM_AVAILABILITY_GET_SUCCESS';
export const TEAM_AVAILABILITY_GET_FAILURE = 'TEAM_AVAILABILITY_GET_FAILURE';

export const ASSIGNMENT_TREATMENT_INSTANCE_GET_REQUEST = 'ASSIGNMENT_TREATMENT_INSTANCE_GET_REQUEST';
export const ASSIGNMENT_TREATMENT_INSTANCE_GET_SUCCESS = 'ASSIGNMENT_TREATMENT_INSTANCE_GET_SUCCESS';
export const ASSIGNMENT_TREATMENT_INSTANCE_GET_FAILURE = 'ASSIGNMENT_TREATMENT_INSTANCE_GET_FAILURE';

export const RESET_ASSIGNMENT_INFO = 'RESET_ASSIGNMENT_INFO';

export const REMOVE_COPY_TREATMENT_INSTANCE = 'REMOVE_COPY_TREATMENT_INSTANCE';

export const GET_SERVICES_DETAILS_REQUEST = 'GET_SERVICES_DETAILS_REQUEST';
export const GET_SERVICES_DETAILS_SUCCESS = 'GET_SERVICES_DETAILS_SUCCESS';
export const GET_SERVICES_DETAILS_FAILURE = 'GET_SERVICES_DETAILS_FAILURE';

export const SCHEDULER_MODE_VIEW_TOGGLE = 'SCHEDULER_MODE_VIEW_TOGGLE';
export const SET_SCHEDULER_MODE = 'SET_SCHEDULER_MODE';
export const OIDC_SESSION_TERMINATED = 'redux-oidc/SESSION_TERMINATED';

export const EXTERNAL_PROVIDER_TYPE_GET_REQUEST = 'EXTERNAL_PROVIDER_TYPE_GET_REQUEST';
export const EXTERNAL_PROVIDER_TYPE_GET_SUCCESS = 'EXTERNAL_PROVIDER_TYPE_GET_SUCCESS';
export const EXTERNAL_PROVIDER_TYPE_GET_FAILURE = 'EXTERNAL_PROVIDER_TYPE_GET_FAILURE';
